import "./ContactUs.css";
import Map from "./Map";
import Offices from "./Offices";

const ContactUs = () => {
  return (
    <div>
      <div className="contact_container container2">
        <div className="contact_div2 ">
          <div className="contact_div21  ">
            <h2>Contact us</h2>
            <div>
            <h6>Crest Digitel Private Limited</h6>
            <span>(Formerly Space Teleinfra Private Limited)</span>
            </div>

            <p>Registered & Corporate Office:</p>
            <div>
            <div className="contact_address">
              Plot No. 278, Ground Floor, A – Square Building, Udyog Vihar,
              Phase II, Gurugram-122002 INDIA
            </div>
            <div>
              <a href="tel:+91-124-4243345">+91-124-4243345 | </a>
              <a href="mailto:info@crestdigitel.com">info@crestdigitel.com</a>
            </div>
            </div>

          </div>
          <div className="contact_map">
            {/* <img src="/assets/contactus/map_img.jpg" alt="" /> */}
            <Map/>
          </div>
        </div>
        <Offices/>
      </div>
    </div>
  );
};

export default ContactUs;
